<template>
  <div
    v-if="$route.meta.header"
    class="header"
    :style="{ height: `${shrink ? shrinkHeight : 80}px` }"
  >
    <h3 class="header-text">
      {{ $route.meta.header }}
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    shrink: { type: Boolean },
    shrinkHeight: { type: Number, required: true },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  color: var(--webeo-purple);
  font-size: 25px;
  text-align: center;
  transition: 0.3s;
  align-items: center;
}
.dark-theme .header {
  border-bottom: 1px solid var(--webeo-white);
}

.header-text {
  font-size: 20px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--webeo-purple);
  display: inline-block;
  padding-left: 30px;
  margin: 0;
  margin-left: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 550px;
  text-align: left;
}
.dark-theme .header-text {
  color: var(--webeo-white);
}
.header-text > span {
  font-weight: 600;
  color: var(--webeo-purple);
}
hr {
  width: 100%;
}
</style>
